<template>
  <div class="row py-1 text-right" :class="[disabled?'disabled' : '']">
    <div v-if="!hasPopover" class="col-md-9">
      <slot name="title"></slot>
    </div>
    <el-popover
      v-else
      class="col-md-9"
      popper-class="popover-price-88"
      placement="bottom"
      width="400"
      trigger="click"
      content="this is content, this is content, this is content"
    >
      <b-button :disabled="disabled" slot="reference" style="height: auto;" class="btn-link text-primary" id="popover-target-free-return">
        <div class="d-flex align-items-center">
          <slot name="title"></slot>
          <i class="ml-1 el-icon-circle-plus-outline"></i>
        </div>
      </b-button>
      <slot name="popover"></slot>
    </el-popover>
    <div class="col-md-3">
      <slot name="price"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasPopover: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-link {
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;
  color: var(--primary) !important;
  text-decoration: none;
}
.disabled {
  pointer-events: none;
}
</style>
